import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls';
import type { ConnectionProviders } from './types';

const DISMISSED_CONNECTORS_STORAGE_KEY = 'third-party-connectors-dismissed-state';

type DismissedStatus = Record<ConnectionProviders, boolean>;

export const getLocalStorageDismissedStatus = () => {
    try {
        const currentStatus = AtlBrowserStorageLocal.getItem(DISMISSED_CONNECTORS_STORAGE_KEY);
        return currentStatus
            ? (JSON.parse(currentStatus) as DismissedStatus)
            : ({ googleDrive: false, sharepoint: false } as DismissedStatus);
    } catch (e) {
        return {
            googleDrive: false,
            sharepoint: false,
        } as DismissedStatus;
    }
};

export const setLocalStorageDismissedStatus = async (provider: ConnectionProviders) => {
    try {
        const dismissedStatus = getLocalStorageDismissedStatus();
        dismissedStatus[provider] = true;
        await AtlBrowserStorageLocal.setItem(DISMISSED_CONNECTORS_STORAGE_KEY, JSON.stringify(dismissedStatus));
    } catch (e) {
        // If local storage is unavailable due to full storage or some other reason, do nothing
    }
};
